module.exports = __webpack_public_path__ + "static/media/icon_level5.fbb82c49.svg";